import { render, staticRenderFns } from "./AdminCard.vue?vue&type=template&id=4c5fb19c&scoped=true&"
import script from "./AdminCard.vue?vue&type=script&lang=ts&"
export * from "./AdminCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5fb19c",
  null
  
)

export default component.exports